enum Freshness {
	Unknown = -1,
	OutOfDate = 0,
	UpToDate = 1
}

export default Freshness;
